import { Model } from '@vuex-orm/core'

export default class Scoreform extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'scoreforms'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      type: this.attr(null),
      interview_type: this.attr(null),
      name: this.attr(null),
      voice_interview: this.attr(null),
      groups: this.attr([]),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Scoreform.js